import React, { useMemo } from 'react';
import cn from 'classnames';
import * as styles from './Tag.module.scss';

function Tag({ mods, children, className, ...rest }) {
  const composeMods = useMemo(() => {
    if (Array.isArray(mods)) {
      return mods.map(m => styles[m]);
    } else {
      return [styles[mods]];
    }
  }, [mods]);

  return (
    <button className={cn(styles.filterTag, className, ...composeMods)} {...rest}>
      {children}
    </button>
  );
}

export default Tag;
